import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'ticketing-hero',
  name: '景区主视觉',
  icon: '景',
  group: '票务组件',
  description: '展示景区名称、营业信息和购票入口。',
  defaultProps: {
    title: '景区官方店',
    subtitle: '官方出票，安心入园',
    imageUrl: '',
    buttonText: '立即购票'
  }
}
